import DataBinder from "../DataBinder.js"
import SwapPage from "../SwapPage.js"
export default class DefaultController {

  constructor() {

  }
  show(path, model) {
    
    //get page
    let pageId = path.split("/")[0];

    const dataBinder = new DataBinder();
    dataBinder.populate(pageId, model);

    const swapPage = new SwapPage();
    swapPage.swapPage(pageId);
  }
}